import { render, staticRenderFns } from "./NewClassDetailsCard.vue?vue&type=template&id=b36c8c78"
import script from "./NewClassDetailsCard.vue?vue&type=script&lang=js"
export * from "./NewClassDetailsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports